import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VehicleListingsGrid from "@/components/index/VehicleListingsGrid";
import { ListingOverview } from "@/types/listing";
import { useTheme } from "@/context/ThemeContext";
import { buildAuctionListingPath } from "@/lib/listingUrl";

/**
 * Minimal page for embedding VehicleListingsGrid in an iframe
 * No header, footer, title, or background - just the listings grid.
 * Always forced to light theme for bilenia.se parent embeds.
 */
const ListingsEmbed = () => {
  const navigate = useNavigate();
  const { setTheme } = useTheme();

  useEffect(() => {
    const previousTheme: "light" | "dark" =
      document.documentElement.classList.contains("dark") ? "dark" : "light";
    setTheme("light");
    return () => {
      setTheme(previousTheme);
    };
  }, [setTheme]);

  const handleCarClick = (listing: ListingOverview) => {
    // Open listing in parent window (if in iframe) or same window
    const targetUrl = buildAuctionListingPath(listing.campaignId, listing);
    const fullUrl = `${window.location.origin}${targetUrl}`;
    
    if (window.parent !== window) {
      // We're in an iframe - open in parent window
      try {
        window.parent.location.href = fullUrl;
      } catch (e) {
        // If cross-origin, use postMessage as fallback
        window.parent.postMessage(
          { type: 'navigate', url: fullUrl },
          '*'
        );
      }
    } else {
      // Not in iframe - navigate normally
      navigate(targetUrl);
    }
  };

  return (
    <div className="min-h-screen w-full bg-transparent p-4 light">
      <VehicleListingsGrid onCarClick={handleCarClick} embedMode={true} />
    </div>
  );
};

export default ListingsEmbed;
